/* globals DEBUG */

/* manually bootstrap app once translations are determined */
(function resolveBootstrap() {

    loadAppAsync()
		.then(function(resolvedLang){ bootstrapApp(resolvedLang); });

    function loadAppAsync() {
		
        var initInjector = angular.injector(['ng', 'phoenix', 'site.settings','gettext']);
        var $http = initInjector.get('$http');
        var pxEnvironmentService = initInjector.get('pxEnvironmentService');
        var settingsService = initInjector.get('settingsService');
        var gettextCatalog = initInjector.get('gettextCatalog');

		// determine the current locale and use angular-gettext to get the
		// correct catalog strings. Also use this info to set the proper path to the
		// terms and conditions (legalLanguage)
		return pxEnvironmentService.loadLanguages()
			.then(function(language){
				language = language.toLowerCase();
				if (language === 'en' || language === 'en-us') {
					return 'en';
				}

				return gettextCatalog.loadRemote('lang/' + language + '.json')
					.then(function(){
						return gettextCatalog.loadRemote('lang/sharebase/' + language + '.json');
					})
					.then(function(){
						return language;
					})
					.catch(function(){
						return 'en';
					});
			})
			.then(function(language) {
				gettextCatalog.setCurrentLanguage(language);

				var tosPath = '/' + language + '/terms-of-use-and-subscription/index.htm';
				return $http.head(settingsService.serverLegalPath + tosPath)
					.then(function() {
						pxEnvironmentService.legalLanguage = language;
						return {lang: gettextCatalog.currentLanguage, legalLang: language, strings: gettextCatalog.strings };
					})
					.catch(function() {
						pxEnvironmentService.legalLanguage = 'en';
						return {lang: gettextCatalog.currentLanguage, legalLang: 'en', strings: gettextCatalog.strings };
					});
			});

    }

    function bootstrapApp(resolvedLang) {
		/* we create a new module 
		 *		- config block to generate MD themes on app load
		 *		- run block to set the resolved language/strings
		 *		- depend on original auto bootstrap module - smb-app.app
		 */
		angular.module('asyncAppLoader',['smb-app.app'])
			.config(['$mdThemingProvider',	function ($mdThemingProvider) {						
				//seems mdThemes are not generated during manual bootstrap, so allow themes to be generated after config block
				$mdThemingProvider.generateThemesOnDemand(true);
			}])
			.run([
				'gettextCatalog',
				'pxEnvironmentService',
				function(gettextCatalog, pxEnvironmentService){					
					//set resolved language
					if(resolvedLang){
						gettextCatalog.setCurrentLanguage(resolvedLang.lang);
						gettextCatalog.strings = resolvedLang.strings;
						pxEnvironmentService.legalLanguage =  resolvedLang.legalLang;
					}
			}]);

		//now bootstrap app
        angular.element(document).ready(function() {
           angular.bootstrap(document, ['asyncAppLoader']);			
        });
    }
}());

(function () {
	'use strict';
	angular.module('smb-app',
		[
			'ngMaterial',
			'ui.router',
			'ngMessages',
			'site.settings',
			'phoenix',
			'phoenix.acl',
			'phoenix.appIdentifier',
			'sharebase',
			'gettext'
		])
		.config([
			'$mdThemingProvider',
			function ($mdThemingProvider) {
				//color theme declarations
				//http://www.google.com/design/spec/style/color.html#color-color-palette
				$mdThemingProvider.definePalette('sharebase', {
					'50': '00586E',
					'100': '7fdcf2',
					'200': 'ebf2f3',
					'300': '00586E',
					'400': '00586E',
					'500': '00586E',
					'600': '00586E',
					'700': '00586E',
					'800': '00586E',
					'900': '00586E',
					'A100': '00586E',
					'A200': '00cbee',
					'A400': '00cbee',
					'A700': '00cbee',
					'contrastDefaultColor': 'dark'   // whether, by default, text (contrast)
				});

				$mdThemingProvider.theme('sharebase')
					.primaryPalette('sharebase', {
						'default': '50',
						'hue-1': '100',
						'hue-2': '200',
						'hue-3': 'A100'
					})
					.accentPalette('blue', {
						'hue-1': '50',
						'hue-2': '100',
						'hue-3': 'A100'
					})
					.warnPalette('red', {
						'default': '500',
						'hue-1': '100',
						'hue-2': '700',
						'hue-3': 'A100'
					});
			}
		])
		.run([
			'gettextCatalog',
			function(gettextCatalog){
				if (DEBUG) {
					gettextCatalog.showTranslatedMarkers = true;
				}
				
		}])
		.controller('smbAppController', ['pxProgressService', 'smbEnvironmentService', '$mdTheming', AppController]);

	function AppController(pxProgressService, smbEnvironmentService, $mdTheming) {
		var vm = this;
		//generate the predefined theme named sharebase
		$mdTheming.generateTheme('sharebase');

		vm.environment = smbEnvironmentService;
		vm.progressUI = pxProgressService;
	}
}());

require('./app.style');
require('./components');
require('./dataStores');
require('./services');



//////////////////
// WEBPACK FOOTER
// ./app/smb-app.js
// module id = 0
// module chunks = 1